import React from 'react';
import { LayoutWithLeftSideMenu } from './LayoutWithLeftSideMenu';

const LayoutWithoutLeftSideMenu = ({ children, ...props }) => {
  return (
    <LayoutWithLeftSideMenu leftSideMenu={null} {...props}>
      {children}
    </LayoutWithLeftSideMenu>
  );
};

export { LayoutWithoutLeftSideMenu };
